import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  class: "cm-align-center",
  style: {"justify-content":"space-between","width":"100%","padding-left":"10px"}
}
const _hoisted_3 = { style: {"font-weight":"bold","font-size":"18px"} }
const _hoisted_4 = { style: {"color":"var(--cm-color-text-secondary)","margin-top":"5px"} }
const _hoisted_5 = { style: {"font-weight":"bold","text-align":"right"} }
const _hoisted_6 = { style: {"color":"var(--cm-color-text-secondary)","text-align":"right","padding-top":"6px"} }
const _hoisted_7 = { class: "cm-ellipsis-line-one" }
const _hoisted_8 = ["innerHTML"]

import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import { computed, nextTick, PropType, reactive, ref, watch } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { useI18n } from 'vue-i18n'
import CmTable from '@/components/cmTable/index.vue';
import CmForm from '@/components/cmForm/index.vue';
import { ActionType, DateType, FormActionType, FormItem, FormSize, FormType } from '@/components/cmForm/types';
import { useParseTime } from '@/hooks';
import { ExcludeRequestParamsSensitiveFileDetail, QueryFormTypeSensitiveFileDetail } from '../types/sensitive-file-scanning';
import Keywords from './Keywords.vue';
import { formatTimeStamp } from '@/utils/time';
import { bytesToSize, formatMapToOptions, highLightKeywords } from '@/utils/tool';
import { GetSensitiveWordsResultsRequestParamsDataRow, GetSensitiveWordsSensitiveFilesResponseDataRow } from '../service';
import DataHistory from './DataHistory.vue';
import { TableOpt, TableActOpt } from '@/components/cmTable/types';
import { listCol } from '@/utils/list-columns-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'sensitive-file-detail',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  device_id: {
    type: String,
    required: true
  },
  detailInfo: {
    type: Object as PropType<GetSensitiveWordsResultsRequestParamsDataRow>,
    required: true,
    default: () => ({})
  },
  hasPermission: {
    type: Boolean,
    required: false
  },
  dataHistoryApi: {
    type: Object,
    required: true
  },
  api: {
    type: Function,
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const { t, locale } = useI18n()
const queryForm = reactive({ device_id: props.device_id } as QueryFormTypeSensitiveFileDetail)
const queryFormDisabled = ref(false)
const dataVisible = ref(false)
const id = ref()
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const queryFormColumns = computed<FormItem<QueryFormTypeSensitiveFileDetail, ExcludeRequestParamsSensitiveFileDetail>[]>(() => {
  void locale.value
  return [
    {
      prop: 'date',
      colOpt: { span: 7 },
      hiddenAllLabel: true,
      type: FormType.Date,
      dateType: DateType.DateRange,
      events: {
        change: (val) => {
          const [start_time, end_time] = useParseTime(val)
          queryForm.start_time = start_time
          queryForm.end_time = end_time
          void refreshList()
        },
      },
      dateOpt: {
        'value-format': 'YYYY-MM-DD',
        'start-placeholder': t('sensitiveFileScanning.startTimePlaceholder'),
        'end-placeholder': t('sensitiveFileScanning.endTimePlaceholder'),
        clearable: true,
      },
    },
    {
      prop: 'keyword',
      colOpt: { span: 7 },
      hiddenAllLabel: true,
      modelModifiers: { trim: true },
      placeholder: t('sensitiveFileScanning.fileNameOrKeywordPlaceholder'),
      inputOpt: {
        'suffix-icon': 'el-icon-search',
      },
      events: {
        blur: () => void refreshList(),
        keypress: (e) => e.charCode === 13 && void refreshList(),
      },
    },
  ]
})

const tableActOpt = computed<TableActOpt>(() => {
  void locale.value
  return {
    columnOpt: { label: t('sensitiveFileScanning.operationRecord'), width: 70, align: 'left', fixed: 'right' },
    isLink: true,
    actionButtons: ({ id }: { id: string }) => [
      {
        name: listCol(t, 'detail'),
        disabled: () => !props.hasPermission,
        type: ActionType.Detail,
        opt: { size: FormSize.Small, type: 'primary' },
        events: {
          click: () => {
            window.open('/dashboard/data-discovery/' + id, '_blank')
          }
        }
      },
    ],
  }
})

const tableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    'default-sort': { prop: 'send_times', order: 'descending' },
    actionBarRowOptStyle: 'margin-bottom: 0;margin-top: 15px',
    height: '100%',
    containerOpt: { style: 'padding: 0;background: var(--cm-color-card-bg)' },
    disabled: false,
    showActionBar: true,
    showForm: false,
    showRightToolbar: false,
    path: 'data',
    rowKey: 'id',
    selection: false,
    columns: [
      { label: listCol(t, 'fileName'), prop: 'name', width: 180, showOverflow: true },
      { label: t('sensitiveFileScanning.hitSensitiveWord'), prop: 'keywords', width: 180 },
      { label: t('sensitiveFileScanning.lastModifyTime'), prop: 'update_time', width: 140, formatter: (_row, value) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') },
      { label: t('sensitiveFileScanning.filePath'), prop: 'path', width: 400 },
      { label: listCol(t, 'fileSize'), prop: 'size', width: 130, formatter: (_row, value) => bytesToSize(value) },
      { label: t('sensitiveFileScanning.fileType'), prop: 'ext', width: 100 },
      { label: t('sensitiveFileScanning.recordTime'), prop: 'create_time', width: 140, formatter: (_row, value) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm') },
      { label: t('sensitiveFileScanning.outboundRecord'), prop: 'send_times', width: 100, fixed: 'right', columnOpt: { sortable: true } },
    ],
  }
})
const emits = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emits('update:modelValue', val)
  }
})
watch(() => props.device_id, async (nv, ov) => {
  await nextTick()
  queryForm.device_id = nv;
  visible.value && nv !== ov && props.hasPermission && void refreshList()
}, {
  immediate: true,
  deep: true
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      title: _ctx.$t('sensitiveFileScanning.detailDrawerTitle', { name: __props.detailInfo.computer_name }),
      size: "950px",
      direction: "rtl",
      style: {"margin-top":"0"}
    }, {
      default: _withCtx(() => [
        _createVNode(CmTable, {
          tableOpt: tableOpt.value,
          tableActOpt: tableActOpt.value,
          api: __props.api,
          "first-loading": false,
          menuRightColOpt: { span: 24 },
          modelValue: queryForm,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
          pageOption: {
        pageNumName: 'page',
        pageSizeName: 'limit',
      },
          ref_key: "tableRef",
          ref: tableRef
        }, {
          header: _withCtx(() => [
            _createVNode(TerminalHead, {
              "system-type": __props.detailInfo.system_type,
              "login-status": __props.detailInfo.login_status
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.detailInfo.computer_name), 1),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.detailInfo.system_name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(__props.detailInfo.user_mark), 1),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.detailInfo.group_name), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["system-type", "login-status"])
          ]),
          "menu-right": _withCtx(() => [
            _createVNode(CmForm, {
              rowOpt: { style: 'justify-content: flex-end' },
              formSize: _unref(FormSize).Small,
              disabled: queryFormDisabled.value,
              "onUpdate:disabled": _cache[0] || (_cache[0] = ($event: any) => ((queryFormDisabled).value = $event)),
              modelValue: queryForm,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm) = $event)),
              formType: _unref(FormActionType).Other,
              "onUpdate:formType": _cache[2] || (_cache[2] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
              formColumns: queryFormColumns.value
            }, null, 8, ["formSize", "disabled", "modelValue", "formType", "formColumns"])
          ]),
          path: _withCtx(({ value = '' }:{value:string}) => [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: value,
              placement: "top-start",
              disabled: value.length<= 44
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(value.length > 44 ? (value.slice(0, 32) + '...' + value.slice(-12)) : (value || '--')), 1)
              ]),
              _: 2
            }, 1032, ["content", "disabled"])
          ]),
          send_times: _withCtx(({ value, row }) => [
            _createVNode(_component_el_link, {
              type: value ? 'primary' : 'default',
              underline: false,
              onClick: _withModifiers(() => { dataVisible.value = !!value;id.value = row.node_id }, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(value), 1)
              ]),
              _: 2
            }, 1032, ["type", "onClick"])
          ]),
          keywords: _withCtx(({ value }) => [
            _createVNode(Keywords, {
              "max-count": 3,
              keywords: value
            }, null, 8, ["keywords"])
          ]),
          name: _withCtx(({ value, row }: { value: string, row: Partial<GetSensitiveWordsSensitiveFilesResponseDataRow> }) => [
            _createElementVNode("div", {
              innerHTML: _unref(highLightKeywords)(value, row.keywords + ''),
              class: "cm-ellipsis-line-one"
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }, 8, ["tableOpt", "tableActOpt", "api", "modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(DataHistory, {
      modelValue: dataVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dataVisible).value = $event)),
      id: id.value,
      api: { recordApi: props.dataHistoryApi.recordApi, fileInfoApi: props.dataHistoryApi.fileInfoApi }
    }, null, 8, ["modelValue", "id", "api"])
  ]))
}
}

})